(function () {
  var autoplayItems = [];
  var gestureArmed = false;
  var visibilityBound = false;
  var ENTER_RATIO = 0.6;
  var EXIT_RATIO = 0.35;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function playButton(wrap) {
    return wrap.querySelector('[data-about-split-play]');
  }

  function markPlaying(wrap, video) {
    wrap.classList.add('is-playing');
    video.setAttribute('controls', '');
    var play = playButton(wrap);
    if (!play) return;
    play.setAttribute('aria-hidden', 'true');
    play.tabIndex = -1;
  }

  function markIdle(wrap, video) {
    wrap.classList.remove('is-playing');
    video.removeAttribute('controls');
    var play = playButton(wrap);
    if (!play) return;
    play.removeAttribute('aria-hidden');
    play.tabIndex = 0;
  }

  function playWithSound(video) {
    video.muted = false;
    video.defaultMuted = false;
    video.removeAttribute('muted');
    video.volume = 1;
    video.playsInline = true;
    return video.play();
  }

  function liveItems() {
    autoplayItems = autoplayItems.filter(function (item) {
      return item.wrap.isConnected;
    });
    return autoplayItems;
  }

  function activeItem() {
    var best = null;
    liveItems().forEach(function (item) {
      var active = item.ratio >= ENTER_RATIO || (item.playing && item.ratio >= EXIT_RATIO);
      if (!active) return;
      if (!best || item.ratio > best.ratio) best = item;
    });
    return best;
  }

  function armGesture() {
    if (gestureArmed) return;
    gestureArmed = true;

    function unlock() {
      document.removeEventListener('pointerdown', unlock, true);
      document.removeEventListener('keydown', unlock, true);
      gestureArmed = false;
      syncAutoplay(true);
    }

    document.addEventListener('pointerdown', unlock, true);
    document.addEventListener('keydown', unlock, true);
  }

  function startItem(item, fromGesture) {
    if (item.pending && !fromGesture) return;
    if (!fromGesture && !item.video.paused && !item.video.ended) return;

    if (item.video.ended) {
      try {
        item.video.currentTime = 0;
      } catch (error) {}
    }

    item.attempt = (item.attempt || 0) + 1;
    var attempt = item.attempt;
    item.pending = true;
    var promise = playWithSound(item.video);
    if (!promise || typeof promise.then !== 'function') {
      item.pending = false;
      item.playing = true;
      markPlaying(item.wrap, item.video);
      return;
    }

    promise.then(function () {
      if (item.attempt !== attempt) return;
      item.pending = false;
      if (activeItem() !== item) {
        item.video.pause();
        item.playing = false;
        markIdle(item.wrap, item.video);
        return;
      }
      item.playing = true;
      markPlaying(item.wrap, item.video);
    }).catch(function () {
      if (item.attempt !== attempt) return;
      item.pending = false;
      item.playing = false;
      markIdle(item.wrap, item.video);
      armGesture();
    });
  }

  function stopItem(item) {
    item.playing = false;
    if (!item.video.paused) item.video.pause();
    markIdle(item.wrap, item.video);
  }

  function syncAutoplay(fromGesture) {
    var current = activeItem();
    liveItems().forEach(function (item) {
      if (item === current) startItem(item, fromGesture);
      else if (item.playing || !item.video.paused) stopItem(item);
    });
  }

  function bindVisibility() {
    if (visibilityBound) return;
    visibilityBound = true;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        liveItems().forEach(function (item) {
          if (!item.video.paused) item.video.pause();
          item.playing = false;
        });
        return;
      }
      syncAutoplay();
    });
  }

  function bindAutoplay(wrap, video, play) {
    var item = {
      wrap: wrap,
      video: video,
      ratio: 0,
      playing: false,
      pending: false,
      attempt: 0
    };
    autoplayItems.push(item);
    bindVisibility();

    play.addEventListener('click', function () {
      item.ratio = 1;
      liveItems().forEach(function (other) {
        if (other !== item) stopItem(other);
      });
      startItem(item, true);
    });

    video.addEventListener('play', function () {
      item.playing = true;
      markPlaying(wrap, video);
    });

    video.addEventListener('pause', function () {
      if (video.ended || item.ratio < EXIT_RATIO) {
        item.playing = false;
        markIdle(wrap, video);
      }
    });

    video.addEventListener('ended', function () {
      item.playing = false;
      markIdle(wrap, video);
    });

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        item.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
      });
      syncAutoplay();
    }, { threshold: [0, 0.25, 0.35, 0.6, 0.75, 1] });

    observer.observe(wrap);
  }

  function bindClickToPlay(wrap, video, play) {
    function startPlayback() {
      wrap.classList.add('is-playing');
      video.setAttribute('controls', '');
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    play.addEventListener('click', startPlayback);
    video.addEventListener('play', function () {
      wrap.classList.add('is-playing');
    });
    video.addEventListener('pause', function () {
      if (video.ended || video.currentTime < 0.2) {
        wrap.classList.remove('is-playing');
      }
    });
    video.addEventListener('ended', function () {
      wrap.classList.remove('is-playing');
      video.removeAttribute('controls');
    });
  }

  function bindSplitVideo(wrap) {
    if (!wrap || wrap.dataset.aboutSplitBound === 'true') return;

    var video = wrap.querySelector('video');
    var play = playButton(wrap);
    if (!video || !play) return;

    wrap.dataset.aboutSplitBound = 'true';

    var autoplay = wrap.getAttribute('data-about-split-autoplay') === 'true' && !reduceMotion();
    if (autoplay) {
      bindAutoplay(wrap, video, play);
      return;
    }

    bindClickToPlay(wrap, video, play);
  }

  function init(root) {
    var scope = root || document;
    var wraps = scope.querySelectorAll('[data-about-split-video]');
    for (var i = 0; i < wraps.length; i++) {
      bindSplitVideo(wraps[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
